import { MESSAGES } from '@guuru/chat-common';
import { appendLocalMessage, ChatAPI } from '@guuru/chat-web';
import events from '@guuru/events-web';
import { delay as sleep } from '@guuru/helpers-common';

const requestName = 'bot:::requestName';

const addBotRequestNameMessage = () =>
  sleep(ChatAPI.getBotEllipsisMessageDelay()).then(() => {
    const message = ChatAPI.messages.createBotMessage(
      Date.now(),
      requestName,
      MESSAGES.message,
      {},
      true,
      false,
    );
    ChatAPI.pushPendingMessages(message);
    return message;
  });

const addNameMessage = (partnerId, name) => {
  const message = ChatAPI.messages.createAnonymousTextMessage(
    name,
    true,
    false,
  );
  ChatAPI.storeName(name);
  ChatAPI.pushPendingMessages(message);
  return message;
};

export default {
  validate() {
    return !ChatAPI.storeRetrieveName();
  },
  async render() {
    events.requestName();

    const requestNameMessage = await addBotRequestNameMessage();
    appendLocalMessage(requestNameMessage);
  },

  processResponse(partnerId, { text }) {
    const message = addNameMessage(partnerId, text);
    events.nameSubmitted(text);
    appendLocalMessage(message);
  },
};
